__turbopack_context__.v({
  "mb": "index-module-scss-module__iy-MqW__mb",
});
